import { Center, Image } from '@chakra-ui/react'
import React from 'react'

function NotFound() {
  return (
    <Center  h='600px' color='white'>
        <Image src="https://img.freepik.com/free-vector/internet-network-warning-404-error-page-file-found-web-page_1150-48326.jpg?w=2000"></Image>
  
</Center>
   
  )
}

export default NotFound